import { Checkbox } from "ant-design-vue";
const { Group, ...other } = Checkbox;
const YwCheckbox = {
	...other,
	name: "YwCheckbox",
	Group: {
		...Group,
		name: "YwCheckboxGroup",
	},
};
YwCheckbox.install = function (Vue) {
	Vue.component(YwCheckbox.name, Checkbox);
	Vue.component(YwCheckbox.Group.name, Group);
};
export default YwCheckbox;
